import h from './hyperscript.js';
export default class Spinner {}
Spinner.create = (messages, options = {}) => {
  if (messages.length <= 0) {
    return null;
  }
  const waitMessage = messages[Math.floor(Math.random() * messages.length)];
  let spinnerContent = [];
  if (waitMessage.video) {
    spinnerContent.push(h('video', {
      autoplay: 'true',
      loop: 'true',
      muted: 'true',
      playsinline: 'true'
    }, h('source', {
      src: waitMessage.video
    })));
  } else if (waitMessage.image) {
    spinnerContent.push(h('img', {
      src: waitMessage.image
    }));
  }
  if (waitMessage.text) {
    spinnerContent.push(h('span', {}, waitMessage.text));
  }
  if (waitMessage.icon) {
    if (waitMessage.text) {
      spinnerContent.push(h('span', {
        class: 'px-1'
      }));
    }
    spinnerContent.push(h('i', {
      class: 'fa-solid fa-2x fa-fw fa-spin ' + waitMessage.icon
    }));
  }
  if (waitMessage.link) {
    spinnerContent = h('a', {
      href: waitMessage.link,
      rel: 'noopener nofollow noreferrer',
      target: '_blank',
      style: 'user-select:none;'
    }, spinnerContent);
  } else {
    spinnerContent = h('div', {
      style: 'user-select:none;'
    }, spinnerContent);
  }
  spinner = h('div', {
    class: options.class
  }, spinnerContent);
  return spinner;
};
Spinner.add = (messages, options = {}) => {
  const spinner = Spinner.create(messages, options);
  if (!spinner) {
    return null;
  }
  document.body.appendChild(spinner);
  return spinner;
};
Spinner.remove = spinner => {
  if (spinner !== null) {
    spinner.remove();
  }
};